var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.53793V26.4621C0 27.5874 0.915955 28.4989 2.04455 28.4989V0.5C0.915955 0.5 0 1.41258 0 2.53793Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75112 27.2589V1.74014C3.75112 1.05604 4.30905 0.5 4.99682 0.5H6.34442V11.9707C5.90359 12.3706 5.53001 12.7943 5.22819 13.1787C5.02173 13.4423 4.84956 13.6861 4.71373 13.8918C4.63261 14.0141 4.56422 14.1225 4.50933 14.2128C4.39598 14.3987 4.3958 14.6004 4.50914 14.7864C4.56404 14.8765 4.63242 14.9854 4.71373 15.1082C4.84956 15.3139 5.02173 15.5577 5.22819 15.8213C5.41386 16.0578 5.6265 16.31 5.86612 16.5611C6.01562 16.7182 6.17525 16.8752 6.34442 17.0282V28.4989H4.99682C4.30905 28.4989 3.75112 27.944 3.75112 27.2589Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7354 10.7265V0.5H8.26345V10.7265C8.79665 10.5096 9.37762 10.3783 10 10.3783C10.6224 10.3783 11.2022 10.5096 11.7354 10.7265Z",
    fill: "url(#paint0_linear_558_1479)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26345 18.2735V28.4989H11.7354V18.2735C11.2022 18.4904 10.6214 18.6217 10 18.6217C9.37856 18.6217 8.79777 18.4904 8.26345 18.2735Z",
    fill: "url(#paint1_linear_558_1479)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6546 0.5H15.0032C15.6898 0.5 16.2479 1.05604 16.2479 1.74014V27.2589C16.2479 27.944 15.6898 28.4989 15.0032 28.4989H13.6546V17.0302C14.0943 16.6303 14.4689 16.2066 14.7707 15.8233C15.1006 15.4021 15.3438 15.0286 15.491 14.7866C15.6042 14.6004 15.604 14.3987 15.4907 14.2126C15.3434 13.9709 15.1004 13.5975 14.7707 13.1767C14.4689 12.7923 14.0943 12.3686 13.6546 11.9698V0.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9554 0.5V28.5C19.085 28.5 20 27.5874 20 26.4632V2.53793C20 1.41258 19.085 0.5 17.9554 0.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26345 13.5197C8.49895 12.2291 9.18784 11.2948 10 11.2948C10.8112 11.2948 11.499 12.2271 11.7354 13.5147C11.7926 13.8247 11.8237 14.1554 11.8237 14.4994C11.8237 14.8436 11.7926 15.1744 11.7354 15.4853C11.499 16.7729 10.8122 17.704 10 17.704C9.18784 17.704 8.49895 16.77 8.26345 15.4803C8.2065 15.1712 8.17633 14.8416 8.17633 14.4994C8.17633 14.1575 8.2065 13.8288 8.26345 13.5197Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_558_1479",
    x1: 2.11031,
    y1: 0.045299,
    x2: 18.7021,
    y2: 28.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_558_1479",
    x1: 2.11031,
    y1: 0.045299,
    x2: 18.7021,
    y2: 28.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA281B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#FFE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BCD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.fd4f0e493caadea6c87fdc8cc2176fd6.svg";
export { ForwardRef as ReactComponent };